import { useEffect, useState } from 'react';

const useHook = () => {

  const vacaciones = false; // para bloquear por vacaciones

  const [year, setYear] = useState<string | number>("");
  const [tematicas, setTematicas] = useState<any[]>([]);

  const setTheYear = () => {
    const d = new Date();
    let theYear = d.getFullYear();
    setYear(theYear);
  };

  const fetchTematicas = async () => {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/tematicas/get-destacadas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const result = await response.json();
      if (result?.data) {
        setTematicas(result.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setTheYear();
    fetchTematicas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    vacaciones,
    year,
    tematicas,
  };
};

export default useHook;
